import moment from 'moment';
import { selector } from 'recoil';

import {
  endpointEnum,
  makeAPIRequest,
} from '../../services/rest/makeAPIRequest';
import { currentMetric } from '../atoms/currentMetric';
import { currentTeam } from '../atoms/currentTeam';
import { groupingState } from '../atoms/grouping';

import { callReportingData } from './callReportingData';
import { methodNameEnum } from './makePHPRequest';

function pad(num) {
  return ('0' + num).slice(-2);
}
function hhmmss(secs) {
  let minutes = Math.floor(secs / 60);
  secs = secs % 60;
  const hours = Math.floor(minutes / 60);
  minutes = minutes % 60;
  return hours + ':' + pad(minutes) + ':' + pad(secs);
}
export const agentSummary = selector({
  key: 'agentSummary',
  get: ({ get }) => {
    try {
      const result = {};
      const arr = [];
      const totalCallsArray = [];
      const totalOutgoingArray = [];
      const totalIncomingArray = [];
      result.charts = [];
      result.stats = [];
      // const BusinessUsers = get(
      //   makePHPRequest({ methodName: methodNameEnum.GET_BUSINESS_USERS })
      // );
      const dataUsers = {
        call: methodNameEnum.GET_BUSINESS_USERS,
      };
      const BusinessUsers = get(
        makeAPIRequest({
          endpoint: endpointEnum.GET_BUSINESS_USERS,
          payloadJsonString: JSON.stringify(dataUsers),
        })
      );
      const report = get(callReportingData(true));
      const current = get(currentTeam);
      const metric = get(currentMetric);
      const { grouping } = get(groupingState);
      const activeUsers =
        BusinessUsers?.response?.data?.result?.filter(
          (o) => o?.isactive === 1
        ) || [];
      result.options = {
        chart: {
          // width: 1500,
          height: 600,
          type: 'spline',
        },
        title: {
          text: current.id
            ? `Agent Reports - ${current.name}`
            : 'Agent Reports',
        },
        xAxis: {
          crosshair: true,
          type: 'datetime',
        },
        yAxis: {
          title: {
            text: `${metric.title}`,
          },
        },
        credits: {
          enabled: false,
        },
        tooltip: {
          shared: true,
        },
        series: [{}],
      };
      result.totalCallsOptions = {
        chart: {
          height: 400,
          type: 'spline',
        },
        title: {
          text: 'Total Calls',
        },
        xAxis: {
          crosshair: true,
          type: 'datetime',
        },
        yAxis: {
          title: {
            text: 'Call Volume',
          },
        },
        credits: {
          enabled: false,
        },
        tooltip: {
          shared: true,
        },
        series: [{}],
      };
      result.outgoingCallsOptions = {
        chart: {
          height: 400,
          type: 'spline',
        },
        title: {
          text: 'Totals Outgoing',
        },
        xAxis: {
          crosshair: true,
          type: 'datetime',
        },
        yAxis: {
          title: {
            text: 'Call Volume',
          },
        },
        tooltip: {
          shared: true,
        },
        credits: {
          enabled: false,
        },
        series: [{}],
      };
      result.incomingCallsOptions = {
        chart: {
          height: 400,
          type: 'spline',
        },
        title: {
          text: 'Totals Incoming',
        },
        xAxis: {
          crosshair: true,
          type: 'datetime',
        },
        yAxis: {
          title: {
            text: 'Call Volume',
          },
        },
        tooltip: {
          shared: true,
        },
        credits: {
          enabled: false,
        },
        series: [{}],
      };
      const totalsCalls = [
        {
          title: 'Outgoing',
          key: 'alloutgoing',
        },
        {
          title: 'Incoming',
          key: 'allincoming',
        },
        {
          title: 'Connections',
          key: 'allconnections',
        },
        {
          title: 'Missed',
          key: 'allmissed',
        },
      ];
      const totalsOutgoing = [
        {
          title: 'Calls',
          key: 'alloutgoing',
        },
        {
          title: 'Answered',
          key: 'outgoinganswered',
        },
        {
          title: 'Connections',
          key: 'outgoingconnection',
        },
        {
          title: 'Total Powerlist Dials',
          key: 'totalPowerlistDials',
        },
      ];
      const totalsIncoming = [
        {
          title: 'Calls',
          key: 'allincoming',
        },
        {
          title: 'Answered',
          key: 'incominganswered',
        },
        {
          title: 'Connection',
          key: 'incomingconnection',
        },
        {
          title: 'Missed',
          key: 'incomingmissed',
        },
      ];
      const reportData = JSON.parse(JSON.stringify(report)).stats.users;
      const chartData = JSON.parse(JSON.stringify(report)).charts;
      const { business } = chartData;
      // find all active users that are in report/chart with matching team (if applicable)
      // transform by pulling existing report/chart into new report
      activeUsers
        .filter(
          (user) =>
            reportData[user.userid] &&
            chartData[user.userid] &&
            (current.id === 0 ||
              user?.teams?.split?.(',')?.includes?.(String(current.id)))
        )
        .forEach((user) => {
          const stats = reportData[user.userid];
          const charts = chartData[user.userid];
          charts.email = user.email;
          stats.email = user.email;
          stats.allcalls = stats.total || 0;
          stats.allmissed = stats.allmissed || 0;
          stats.allanswered = stats.allanswered || 0;
          stats.allduration = stats.allduration || 0;
          stats.alldurationsum = stats.alldurationsum || 0;
          stats.alldurationavg = stats.alldurationavg || 0;
          stats.allconnections = stats.allconnections || 0;
          stats.allavgduration = stats.alldurationavg || 0;
          stats.answeredDurationSum = stats.answeredDurationSum || 0;
          stats.answeredDurationSumNum = stats.answeredDurationSum || 0;
          stats.tduration = +(
            (stats.alldurationavg * stats.total) /
            60
          ).toFixed(2);
          stats.tdurationhhmmss = hhmmss(stats.tduration);
          stats.tdurationread = stats.avgduration = hhmmss(
            Math.ceil(stats.alldurationsum)
          );
          stats.allavgduration2 = stats.alldurationavg || 0;
          stats.avgduration = hhmmss(Math.ceil(stats.allavgduration2));
          stats.alldurationsummin = parseFloat(
            (stats.alldurationsum / 60).toFixed(2)
          );
          stats.alldurationavgmin = parseFloat(
            (stats.allavgduration / 60).toFixed(2)
          );
          stats.allavgduration = stats.allavgduration
            ? hhmmss(Math.ceil(stats.allavgduration))
            : '00:00:00';
          stats.answeredDurationSum = stats.answeredDurationSum
            ? hhmmss(Math.ceil(stats.answeredDurationSum))
            : '00:00:00';
          stats.allincoming = stats.allincoming || 0;
          stats.incomingmissed = stats.incomingmissed || 0;
          stats.incomingmissed_pct =
            ((stats.incomingmissed / stats.allincoming) * 100)
              .toFixed(1)
              .toString() + '%' || 0;
          stats.incomingmissed_pct =
            stats.incomingmissed_pct === 'NaN%'
              ? '0.0%'
              : stats.incomingmissed_pct;
          stats.incominganswered = stats.incominganswered || 0;
          stats.duration = stats.duration || 0;
          stats.incomingconnection = stats.incomingconnection || 0;
          stats.outgoingcalls = stats.alloutgoing || 0;
          stats.outgoingmissed = stats.outgoingmissed || 0;
          stats.outgoinganswered = stats.outgoinganswered || 0;
          stats.outgoingduration = stats.outgoingduration || 0;
          stats.outgoingconnection = stats.outgoingconnection || 0;
          stats.outgoingconnection_pct =
            ((stats.outgoingconnection / stats.outgoinganswered) * 100)
              .toFixed(1)
              .toString() + '%' || 0;
          stats.outgoingconnection_pct =
            stats.outgoingconnection_pct === 'NaN%'
              ? '0.0%'
              : stats.outgoingconnection_pct;
          if (charts[metric.key]) {
            const data = charts[metric.key];
            if (data.length > 0) {
              const obj = {};
              obj.name = charts.email;
              switch (grouping) {
                case 'Week': {
                  const reduced = Object.entries(
                    data
                      .map((item) => [
                        Date.parse(
                          moment(item[0]).startOf('week').format('YYYY-MM-DD')
                        ),
                        item[1],
                      ])
                      .reduce(
                        (acc, [date, amount]) => ({
                          ...acc,
                          [date]: amount + (acc[date] ? acc[date] : 0),
                        }),
                        {}
                      )
                  ).map((item) => [+item[0], item[1]]);

                  result.options.plotOptions = {
                    series: {
                      animationLimit: Infinity,
                      pointStart: +reduced[0][0],
                      pointInterval: 24 * 7 * 3600 * 1000,
                      pointIntervalUnit: 'week',
                    },
                  };
                  obj.data = reduced;
                  break;
                }
                case 'Month': {
                  const reducedMonth = Object.entries(
                    data
                      .map((item) => [
                        Date.parse(
                          moment(item[0]).startOf('month').format('YYYY-MM-DD')
                        ),
                        item[1],
                      ])
                      .reduce(
                        (acc, [date, amount]) => ({
                          ...acc,
                          [date]: amount + (acc[date] ? acc[date] : 0),
                        }),
                        {}
                      )
                  ).map((item) => [+item[0], item[1]]);
                  result.options.plotOptions = {
                    series: {
                      pointStart: reducedMonth[0][0],
                      pointIntervalUnit: 'month',
                    },
                  };
                  obj.data = reducedMonth;
                  break;
                }
                default: {
                  const defaultReduce = Object.entries(
                    data
                      .map((item) => [
                        Date.parse(moment(item[0]).format('YYYY-MM-DD')),
                        item[1],
                      ])
                      .reduce(
                        (acc, [date, amount]) => ({
                          ...acc,
                          [date]: amount + (acc[date] ? acc[date] : 0),
                        }),
                        {}
                      )
                  ).map((item) => [+item[0], item[1]]);
                  result.options.plotOptions = {
                    series: {
                      pointStart: defaultReduce[0][0],
                      pointInterval: 1,
                    },
                  };
                  obj.data = defaultReduce;
                  break;
                }
              }
              arr.push(obj);
            }
          }
          // object with email and data for that email pushed into series arr
          result.stats.push(stats);
          result.charts.push(charts);
          result.options.series = arr;
          result.businessReport = business;
        });
      switch (grouping) {
        case 'Week':
          totalsCalls.forEach((i) => {
            const totalCallsObj = {};
            // map over total calls array which holds titls and key of metrics needed to display, key must be name for obj
            totalCallsObj.name = i.title;
            if (business[i.key]) {
              const businessDataReducedWeek = Object.entries(
                business[i.key]
                  .map((item) => [
                    Date.parse(
                      moment(item[0]).startOf('week').format('YYYY-MM-DD')
                    ),
                    item[1],
                  ])
                  .reduce(
                    (acc, [date, amount]) => ({
                      ...acc,
                      [date]: amount + (acc[date] ? acc[date] : 0),
                    }),
                    {}
                  )
              ).map((item) => [+item[0], item[1]]);
              if (businessDataReducedWeek[0]) {
                result.totalCallsOptions.plotOptions = {
                  series: {
                    pointStart: +businessDataReducedWeek[0][0],
                    pointInterval: 24 * 7 * 3600 * 1000,
                    pointIntervalUnit: 'week',
                  },
                };
              }
              totalCallsObj.data = businessDataReducedWeek;
            }
            totalCallsArray.push(totalCallsObj);
          });
          totalsOutgoing.forEach((i) => {
            const totalOutgoingObj = {};
            // map over total calls array which holds titls and key of metrics needed to display, key must be name for obj
            totalOutgoingObj.name = i.title;
            if (business[i.key]) {
              const businessDataReducedWeek = Object.entries(
                business[i.key]
                  .map((item) => [
                    Date.parse(
                      moment(item[0]).startOf('week').format('YYYY-MM-DD')
                    ),
                    item[1],
                  ])
                  .reduce(
                    (acc, [date, amount]) => ({
                      ...acc,
                      [date]: amount + (acc[date] ? acc[date] : 0),
                    }),
                    {}
                  )
              ).map((item) => [+item[0], item[1]]);
              if (businessDataReducedWeek[0]) {
                result.outgoingCallsOptions.plotOptions = {
                  series: {
                    pointStart: +businessDataReducedWeek[0][0],
                    pointInterval: 24 * 7 * 3600 * 1000,
                    pointIntervalUnit: 'week',
                  },
                };
              }
              totalOutgoingObj.data = businessDataReducedWeek;
            }
            totalOutgoingArray.push(totalOutgoingObj);
          });
          totalsIncoming.forEach((i) => {
            const totalIncomingObj = {};
            // map over total calls array which holds titls and key of metrics needed to display, key must be name for obj
            totalIncomingObj.name = i.title;
            if (business[i.key]) {
              const businessDataReducedWeek = Object.entries(
                business[i.key]
                  .map((item) => [
                    Date.parse(
                      moment(item[0]).startOf('week').format('YYYY-MM-DD')
                    ),
                    item[1],
                  ])
                  .reduce(
                    (acc, [date, amount]) => ({
                      ...acc,
                      [date]: amount + (acc[date] ? acc[date] : 0),
                    }),
                    {}
                  )
              ).map((item) => [+item[0], item[1]]);
              if (businessDataReducedWeek[0]) {
                result.incomingCallsOptions.plotOptions = {
                  series: {
                    pointStart: +businessDataReducedWeek[0][0],
                    pointInterval: 24 * 7 * 3600 * 1000,
                    pointIntervalUnit: 'week',
                  },
                };
              }
              totalIncomingObj.data = businessDataReducedWeek;
            }
            totalIncomingArray.push(totalIncomingObj);
          });
          break;
        case 'Month':
          totalsCalls.forEach((i) => {
            const totalCallsObj = {};
            // map over total calls array which holds titls and key of metrics needed to display, key must be name for obj
            totalCallsObj.name = i.title;
            if (business[i.key]) {
              const businessDataReducedMonth = Object.entries(
                business[i.key]
                  .map((item) => [
                    Date.parse(
                      moment(item[0]).startOf('month').format('YYYY-MM-DD')
                    ),
                    item[1],
                  ])
                  .reduce(
                    (acc, [date, amount]) => ({
                      ...acc,
                      [date]: amount + (acc[date] ? acc[date] : 0),
                    }),
                    {}
                  )
              ).map((item) => [+item[0], item[1]]);
              if (businessDataReducedMonth[0]) {
                result.totalCallsOptions.plotOptions = {
                  series: {
                    pointStart: businessDataReducedMonth[0][0],
                    pointIntervalUnit: 'month',
                  },
                };
              }
              totalCallsObj.data = businessDataReducedMonth;
            }
            totalCallsArray.push(totalCallsObj);
          });
          totalsOutgoing.forEach((i) => {
            const totalOutgoingObj = {};
            // map over total calls array which holds titls and key of metrics needed to display, key must be name for obj
            totalOutgoingObj.name = i.title;
            if (business[i.key]) {
              const businessDataReducedMonth = Object.entries(
                business[i.key]
                  .map((item) => [
                    Date.parse(
                      moment(item[0]).startOf('month').format('YYYY-MM-DD')
                    ),
                    item[1],
                  ])
                  .reduce(
                    (acc, [date, amount]) => ({
                      ...acc,
                      [date]: amount + (acc[date] ? acc[date] : 0),
                    }),
                    {}
                  )
              ).map((item) => [+item[0], item[1]]);
              if (businessDataReducedMonth[0]) {
                result.outgoingCallsOptions.plotOptions = {
                  series: {
                    animationLimit: Infinity,
                    pointStart: businessDataReducedMonth[0][0],
                    pointIntervalUnit: 'month',
                  },
                };
              }
              totalOutgoingObj.data = businessDataReducedMonth;
            }
            totalOutgoingArray.push(totalOutgoingObj);
          });
          totalsIncoming.forEach((i) => {
            const totalIncomingObj = {};
            // map over total calls array which holds titls and key of metrics needed to display, key must be name for obj
            totalIncomingObj.name = i.title;
            if (business[i.key]) {
              const businessDataReducedMonth = Object.entries(
                business[i.key]
                  .map((item) => [
                    Date.parse(
                      moment(item[0]).startOf('month').format('YYYY-MM-DD')
                    ),
                    item[1],
                  ])
                  .reduce(
                    (acc, [date, amount]) => ({
                      ...acc,
                      [date]: amount + (acc[date] ? acc[date] : 0),
                    }),
                    {}
                  )
              ).map((item) => [+item[0], item[1]]);
              if (businessDataReducedMonth[0]) {
                result.incomingCallsOptions.plotOptions = {
                  series: {
                    pointStart: businessDataReducedMonth[0][0],
                    pointIntervalUnit: 'month',
                  },
                };
              }
              totalIncomingObj.data = businessDataReducedMonth;
            }
            totalIncomingArray.push(totalIncomingObj);
          });
          break;
        default:
          totalsCalls.forEach((i) => {
            const totalCallsObj = {};
            // map over total calls array which holds titls and key of metrics needed to display, key must be name for obj
            totalCallsObj.name = i.title;
            if (business[i.key]) {
              const businessData = Object.entries(
                business[i.key]
                  .map((item) => [
                    Date.parse(moment(item[0]).format('YYYY-MM-DD')),
                    item[1],
                  ])
                  .reduce(
                    (acc, [date, amount]) => ({
                      ...acc,
                      [date]: amount + (acc[date] ? acc[date] : 0),
                    }),
                    {}
                  )
              ).map((item) => [+item[0], item[1]]);
              if (businessData[0]) {
                result.totalCallsOptions.plotOptions = {
                  series: {
                    pointStart: businessData[0][0],
                    pointInterval: 1,
                  },
                };
              }
              totalCallsObj.data = businessData;
              totalCallsArray.push(totalCallsObj);
            }
          });
          totalsOutgoing.forEach((i) => {
            const totalOutgoingObj = {};
            // map over total calls array which holds titls and key of metrics needed to display, key must be name for obj
            totalOutgoingObj.name = i.title;
            if (business[i.key]) {
              const defaultData = Object.entries(
                business[i.key]
                  .map((item) => [
                    Date.parse(moment(item[0]).format('YYYY-MM-DD')),
                    item[1],
                  ])
                  .reduce(
                    (acc, [date, amount]) => ({
                      ...acc,
                      [date]: amount + (acc[date] ? acc[date] : 0),
                    }),
                    {}
                  )
              ).map((item) => [+item[0], item[1]]);
              if (defaultData[0]) {
                result.outgoingCallsOptions.plotOptions = {
                  series: {
                    pointStart: defaultData[0][0],
                    pointInterval: 1,
                  },
                };
              }

              totalOutgoingObj.data = defaultData;
              totalOutgoingArray.push(totalOutgoingObj);
            }
          });
          totalsIncoming.forEach((i) => {
            const totalIncomingObj = {};
            // map over total calls array which holds titls and key of metrics needed to display, key must be name for obj
            totalIncomingObj.name = i.title;
            if (business[i.key]) {
              const defaultData = Object.entries(
                business[i.key]
                  .map((item) => [
                    Date.parse(moment(item[0]).format('YYYY-MM-DD')),
                    item[1],
                  ])
                  .reduce(
                    (acc, [date, amount]) => ({
                      ...acc,
                      [date]: amount + (acc[date] ? acc[date] : 0),
                    }),
                    {}
                  )
              ).map((item) => [+item[0], item[1]]);
              if (defaultData[0]) {
                result.outgoingCallsOptions.plotOptions = {
                  series: {
                    pointStart: defaultData[0][0],
                    pointInterval: 1,
                  },
                };
              }
              totalIncomingObj.data = defaultData;
              totalIncomingArray.push(totalIncomingObj);
            }
          });
          break;
      }
      //we need to do this because the data points aren't always sorted by date but the chart always plots the points in order of the arrays.
      //so in order to solve ENG-3678, we have to sort the arrays by date.
      totalCallsArray.map((element) => {
        if (Array.isArray(element.data)) {
          element.data.sort((a, b) => a[0] - b[0]);
        }
      });
      totalOutgoingArray.map((element) => {
        if (Array.isArray(element.data)) {
          element.data.sort((a, b) => a[0] - b[0]);
        }
      });
      totalIncomingArray.map((element) => {
        if (Array.isArray(element.data)) {
          element.data.sort((a, b) => a[0] - b[0]);
        }
      });
      result.totalCallsOptions.series = totalCallsArray;
      result.outgoingCallsOptions.series = totalOutgoingArray;
      result.incomingCallsOptions.series = totalIncomingArray;
      return result;
    } catch (error) {
      const result = error;
      return result;
    }
  },
});
